import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { dequeueNotifications } from '../../reducers/notificationReducer'
import useTheme from '@mui/material/styles/useTheme'

const Notification = () => {
    const theme = useTheme()
    const small_screen = theme.breakpoints.values.sm
    const queue = useSelector(state => state.notifications.queue)
    const dispatch = useDispatch()

    // if on mobile notif on bottom right otehr wise top center
    useEffect(() => {
        if (!queue.length) return
        const position = window.innerWidth > small_screen ? 'top-center' : 'bottom-right'
        queue.forEach(({ kind, message }) => {
            toast[kind](message, {
                position,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        })
        dispatch(dequeueNotifications(queue.length))
    }, [queue, dispatch, small_screen])

    return (
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    )
}

export default Notification
